/** 비밀번호 암호화 함수 */
export const encryptPassword = async (phoneNumber: string, password: string): Promise<string> => {
  const secretKey = `${phoneNumber}+codepay`.padEnd(32, '#');

  // 키를 바이트 배열로 변환
  const keyData = new TextEncoder().encode(secretKey.slice(0, 32)); // 32바이트로 제한

  // 암호화 키 생성
  const cryptoKey = await crypto.subtle.importKey('raw', keyData, { name: 'AES-CBC', length: 256 }, false, ['encrypt']);

  // 초기화 벡터(IV) 생성 - 16바이트
  const iv = crypto.getRandomValues(new Uint8Array(16));

  // 비밀번호를 바이트 배열로 변환
  const passwordData = new TextEncoder().encode(password);

  // 암호화
  const encryptedData = await crypto.subtle.encrypt({ name: 'AES-CBC', iv }, cryptoKey, passwordData);

  // 암호화된 데이터와 IV를 Base64로 인코딩
  const encryptedArray = new Uint8Array(encryptedData);
  const encryptedBase64 = btoa(String.fromCharCode(...encryptedArray));
  const ivBase64 = btoa(String.fromCharCode(...iv));

  // IV와 암호화된 데이터를 구분자로 연결
  return `${ivBase64}.${encryptedBase64}`;
};
